import React from "react";
import { Reveal, Section, Container, EyebrowLarge } from "./Shared";
import { Handshake, Users, Lightbulb, Rocket } from "lucide-react";

const steps = [
    {
        icon: Handshake,
        t: "Partner",
        d: "We work through a trusted network of industry leaders to unlock meaningful value.",
    },
    {
        icon: Users,
        t: "Collaborate",
        d: "Integrated expertise ensures seamless execution across every stage.",
    },
    {
        icon: Lightbulb,
        t: "Innovate",
        d: "Continuous improvement drives smarter, scalable solutions.",
    },
    {
        icon: Rocket,
        t: "Enable",
        d: "Support, refinement and ongoing optimization to help you thrive in a changing market.",
    },
];

export default function HowWeWork() {
    return (
        <Section id="how" className="relative font-body py-24 md:py-32">
            {/* Background Ambience */}
            <div className="absolute top-40 left-0 w-[500px] h-[500px] rounded-full blur-[120px] pointer-events-none opacity-10" style={{ background: 'var(--ivani-color)' }} />
            <div className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full blur-[100px] pointer-events-none opacity-10" style={{ background: 'var(--ivani-color)' }} />


            <Container>
                <div className="text-center mb-8 md:mb-20">
                    <EyebrowLarge className="mb-4">HOW WE WORK</EyebrowLarge>
                    <p className="text-zinc-400 text-lg max-w-2xl mx-auto font-light">
                        A systematic approach to delivering value.
                    </p>
                </div>

                {/* Compact Process Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {steps.map((s, i) => (
                        <Reveal key={s.t} className="h-full" delay={i * 0.1}>
                            <div className="group h-full glass-card p-4 rounded-3xl border border-white/10 hover:border-white/20 transition-all duration-500 hover:shadow-xl flex flex-col relative overflow-hidden hover:-translate-y-2 hover:scale-[1.02]">

                                {/* Noise Texture */}
                                <div className="absolute inset-0 bg-noise opacity-10 pointer-events-none z-0 mix-blend-overlay"></div>

                                {/* Large Background Icon Watermark */}
                                <s.icon className="absolute -bottom-6 -right-6 w-32 h-32 text-white opacity-5 -rotate-12 pointer-events-none transition-transform duration-700 group-hover:scale-110 z-0" />

                                <div className="flex-1 flex flex-col relative z-20">
                                    {/* Icon */}
                                    <div className="mb-6">
                                        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/5 border border-white/10 shadow-inner group-hover:scale-110 transition-transform duration-500">
                                            <s.icon className="h-7 w-7 text-white transition-colors" />
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <h4 className="font-heading text-xl font-bold text-white mb-3 group-hover:text-white transition-colors">{s.t}</h4>
                                    <p className="text-zinc-400 text-base md:text-lg max-w-2xl mx-auto font-light">
                                        {s.d}
                                    </p>

                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </Container>
        </Section>
    );
}
